import React, { useState } from 'react'
import styled from 'styled-components'
import NameList from './name-list'
import Toggle from './toggle'
import OptionWithBar from './option-with-bar'
import PollHeading from './poll-heading'

const Container = styled.li`
  background: ${props => props.theme._neo.ui05};
  border-radius: 6px;
  display: block;
  margin-bottom: 16px;
  padding: 16px;
`

const OptionContainer = styled.div`
  margin-bottom: 16px;
`

const Poll = ({
  question,
  creator,
  answers
}) => {
  const [isExpanded, setExpanded] = useState(false)
  const toggle = () => setExpanded(!isExpanded)

  return (
    <Container>
      <PollHeading creator={creator} question={question} />
      {answers.map(answer => {
        const { voters, key, name, percent } = answer
        const { length: votes } = voters

        return (
          <OptionContainer key={key}>
            <OptionWithBar
              percent={percent}
              votes={votes}
            >
              {name}
            </OptionWithBar>
            {isExpanded && votes > 0 && <NameList items={voters} />}
          </OptionContainer>
        )
      }
      )}
      <Toggle isExpanded={isExpanded} onToggle={toggle} />
    </Container>
  )
}

export default Poll
